import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";

export class SolicitacaoArquivos extends BaseEntity {

  public cnpjAgenteFinanceiro: string;
  public codigoTipoSolicitacao: TipoSolicitacaoArquivos;
  public agenteFinanceiro: AgenteFinanceiro;
  public dataSolicitacaoIni: Date;
 	public dataSolicitacaoFim: Date;
  public dataSolicitacao: Date;
  public codigoTipoSolicitacaoArquivo: string;
}

export class TipoSolicitacaoArquivos extends BaseEntity {

  public codigo: string;
  public nome: string;
}

export enum TipoSolicitacaoArquivo {
  EMPRESAS_BLOQUEADAS = '1'
}

export const LabelTipoSolicitacaoArquivo = new Map<string, string> ([
  [TipoSolicitacaoArquivo.EMPRESAS_BLOQUEADAS, 'Empresas Bloqueadas']
])
